"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var AccountWrapper = function AccountWrapper(_ref) {
  var children = _ref.children,
    image = _ref.image;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "grid d8-account-wrapper d8-u-white-bg"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "col-6@sm"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "max-width-xxs margin-auto"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "d8-u-component-padding"
  }, children))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "col-6@sm d8-u-bg-img hidden-xs",
    style: {
      backgroundImage: "url(".concat(image, ")")
    }
  }));
};
AccountWrapper.propTypes = {
  children: _propTypes["default"].oneOfType([_propTypes["default"].node, _propTypes["default"].arrayOf(_propTypes["default"].node), _propTypes["default"].func]).isRequired,
  image: _propTypes["default"].string
};
var _default = exports["default"] = AccountWrapper;